import { useTranslation } from 'react-i18next';

import { Box, Typography } from '@mui/material';

import { FormikPhone } from '@/components/formik/FormikPhone';
import { FormikText } from '@/components/formik/FormikText';

import { styles } from '../MemberModal.styles';
import { MemberRoles } from '../MemberRoles';

export const InviteMemberFields = () => {
  const { t } = useTranslation();

  return (
    <Box sx={styles.fields}>
      <Typography variant="h5" sx={styles.header}>
        {t('members.userForm.addNew')}
      </Typography>

      <FormikPhone
        name="phone"
        label="members.userForm.phoneNumber"
        countryLabel="formLabels.country"
      />

      <FormikText name="firstName" label="members.userForm.firstName" />

      <Typography component="p" variant="caption" color="text.secondary">
        {t('members.userForm.permissions')}
      </Typography>

      <MemberRoles />
    </Box>
  );
};
